import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';
import { showResult } from 'infrastructure/hooks/utils';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';
import { useUpdateAssigneeAssignTool } from 'infrastructure/hooks/assign-patient';

import type { IAssignToolResponse } from 'infrastructure/interfaces';

const url = 'reports/reports/interactive-time-dashboard-my-assigns';

const defaultQueries = {
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
  assignExpireDirection: 'desc',
};

export const getAssignToolQueryKey = () => [
  'assignPatientsTool',
  defaultQueries,
];

const queryFn = async () => {
  const { data, error } = await dataService.getList<IAssignToolResponse>(
    apiUrlGenerator(url, defaultQueries),
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetAssignToolData = () => {
  const queryKey = getAssignToolQueryKey();

  const { data, isLoading, error } = useQuery<
    IAssignToolResponse | undefined,
    string | undefined
  >({
    queryKey,
    queryFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  useUpdateAssigneeAssignTool(queryKey);

  return { data, isLoading };
};
